import BookingsModal from "./BookingsModal";
export default BookingsModal;
